import React from "react";
import { BodyContainer } from "./index.styled";
import CardBodyItem from "../CardBodyItem";

interface CardItem {
  title: string;
  value: number;
  type: string;
}

interface CardBodyProps {
  cards: CardItem[];
}

const CardBody: React.FC<CardBodyProps> = ({ cards }) => {
  return (
    <BodyContainer>
      {cards.map((cardItem, index) => (
        <React.Fragment key={index}>
          <CardBodyItem
            title={cardItem.title}
            value={cardItem.value}
            type={cardItem.type}
          />
          {index !== cards.length - 1 && <div className="separator" />}
        </React.Fragment>
      ))}
    </BodyContainer>
  );
};

export default CardBody;
